import { usePostHttp } from "../../http.hook";
import type { IOtp } from "../../../../types/models/otp.models.types";

interface IBody {
  phoneNumber: string;
}

interface IOtpResponse extends IOtp {}

export function useVerifyPhoneSendOtpBrandHttp() {
  return usePostHttp<IBody, IOtpResponse>({
    path: "/brand/profile/phone/otp/send",
  });
}
